export const ProfileConstant = {
    Dev :'Dev',
    load :'load',
    Test :'Test' ,
    UAT :'UAT',
    Prod:'Prod'
}